<template>
  <p ref="refTextSubId" :dir>
    <AnimationTyping
      :is-visible="messageDetails.highlight && isLastSubId"
      :text="messageDetails.content"
      :dir
      :is-keep-all="!isLanguageNoSpace(messageDetails.languageCode)"
    />
    <span v-if="!messageDetails.highlight || !isLastSubId" @click="emit('edit', messageDetails)">
      {{ messageDetails.messageEdited ? messageDetails.messageEdited : messageDetails.content }}
    </span>
  </p>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';

import AnimationTyping from '@/components/animations/AnimationTyping.vue';
import { MessageText } from '@/types/socket';
import { isLanguageNoSpace } from '@/utils/chat/language';

defineProps<{ messageDetails: MessageText; isLastSubId: boolean; dir: string }>();
const emit = defineEmits<{
  edit: [messageDetails: MessageText];
}>();

const refTextSubId = useTemplateRef('refTextSubId');

defineExpose({
  refTextSubId,
});
</script>

<style scoped></style>
